/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Resetable } from '../../resetter/resetable';
import { Syncable } from '../../sync/syncable';
import { Equipment } from 'src/app/_model/equipments';
import { IMSId } from 'src/app/_model/ims-object';
import { InitializeAware, InitializeStatus } from '../../initialize/initialize-aware';
import { APILevel } from '../../sync/api-level';

/**
 * Interface Definition for a EquipmentsService
 */
@Injectable()
export abstract class EquipmentsService implements Resetable, Syncable, InitializeAware {
  /**
   * Behaviour Subject notifing about new [[Equipment]]es
   */
  public equipments$: BehaviorSubject<Equipment[]>;

  public abstract getEquipmentById(id: IMSId): Equipment;

  // Clearable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;

  // Syncable
  public abstract postsync(): Promise<void>;
  public abstract sync(apiLevel: APILevel, syncKey: string): Promise<void>;
  public abstract presync(): Promise<void>;

  // Initialize Aware
  public initializeStatus$: BehaviorSubject<InitializeStatus>;
  abstract initialize(): Promise<void>
  abstract initializeCompleted(): Promise<void>
}
